<div class="rd-widget">
  <table data-id="widgetFrontpage" class="widget-large widgetNoTopBorder cellspacing-0 cellpadding-0" numberoflines="" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent">
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>

        <th class="widget-grid-space"> &nbsp;</th>
        <th class="widget-grid-space"> &nbsp;</th>

        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
        <th class="widget-grid-column"> &nbsp;</th>
      </tr>
    </thead>
    <tbody *ngIf="widgetData">
      <tr>
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'valuationPortfolioValuationDate'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="5">
          <widget-value [align]="'right'" [bold]="true">{{widgetData.valuationPortfolioValuationDate | rdLocalizedDate}}</widget-value>
        </td>
        <td colspan="2" class="space"> &nbsp;</td>
        <td colspan="3"><widget-label [widget]="this" [fieldName]="'valuationPortfolioValuationPortfolioName'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="6">
          <widget-value [align]="'right'" [bold]="true">{{widgetData.valuationPortfolioValuationPortfolioName}}</widget-value>
        </td>
      </tr>
      <tr *ngIf="editMode">
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'reportValuationInspectionDate'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="5">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl [(ngModel)]="widgetData.reportValuationInspectionDate" (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
        </td>
        <td colspan="2" class="space"> &nbsp;</td>
        <td colspan="3"><widget-label [widget]="this" [fieldName]="'valuationPortfolioClientManual'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="6">
          <widget-value [align]="'right'" [bold]="true">{{widgetData.valuationPortfolioClientManual}}</widget-value>
        </td>
      </tr>
      <tr *ngIf="!editMode">
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'reportValuationInspectionDate'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="5">
          <widget-value [align]="'right'" [bold]="true">{{widgetData.reportValuationInspectionDate | rdLocalizedDate}}</widget-value>
        </td>
        <td colspan="2" class="space"> &nbsp;</td>
        <td colspan="3"><widget-label [widget]="this" [fieldName]="'valuationPortfolioClientManual'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="6">
          <widget-value [align]="'right'" [bold]="true">{{widgetData.valuationPortfolioClientManual}}</widget-value>
        </td>
      </tr>
    </tbody>
  </table>
</div>
